module.exports = __webpack_public_path__ + "img/under-maintenance.55285544.svg";